import * as yup from "yup";

const MedicalRegistrationSchema = yup.object().shape({
  medical_reg_no: yup
    .string()
    .trim()
    .matches(
      /^[a-zA-Z0-9]*$/,
      "Medical registration number must contain alphanumeric characters only"
    )
    .max(255, "Medical registration number is not valid")
    .required("Medical registration number is required and must be valid"),
  // govt_issued_photo_url: yup.object().required(),
  // medical_registration_certificate_url: yup.object().required(),
  // signature_url: yup.object().required(),
  // profile_picture_url: yup.object().required(),

  referral_code: yup
    .string()
    .trim()
    .matches(
      /^[0-9]*$/,
      "Please add a valid employee referral code (4-6 digit number)"
    )
    .max(6, "Please add a valid employee referral code (4-6 digit number)")
    .min(4, "Please add a valid employee referral code (4-6 digit number)"),
});

export default MedicalRegistrationSchema;
